<template>
  <ion-page>
    <!--content start -->
    <ion-content>
      <div class="container-support">
        <ion-row>
          <ion-col size="4">
            <router-link to="/support" replace
              ><ion-icon class="back-icon" src="assets/icon/arrow-left.svg"
            /></router-link>
          </ion-col>
          <ion-col size="8">
            <span class="h1-label">Send Email Support</span>
          </ion-col>
        </ion-row>
      </div>
      <ion-row router-link="/support" class="support-row">
        <ion-col size="12" style="margin-top: 40px">
          <span class="h1-label">Please Fill out fields below.</span>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <!-- form start -->
          <form @submit.prevent="handleSubmit">
            <ion-item>
              <ion-label position="floating" class="h1-label">Name</ion-label>
              <ion-input
                v-model="form.name"
                required
                class="h1-text"
              ></ion-input>
            </ion-item>
            <span v-if="errors.name" class="error-message">{{
              errors.name
            }}</span>

            <ion-item>
              <ion-label position="floating" class="h1-label">Email</ion-label>
              <ion-input
                v-model="form.email"
                type="email"
                class="h1-text"
                required
              ></ion-input>
            </ion-item>
            <span v-if="errors.email" class="error-message">{{
              errors.email
            }}</span>

            <ion-item>
              <ion-label position="floating" class="h1-label"
                >Message</ion-label
              >
              <ion-textarea
                v-model="form.message"
                :auto-grow="true"
                required
                rows="7"
                class="h1-text"
              ></ion-textarea>
            </ion-item>
            <span v-if="errors.message" class="error-message">{{
              errors.message
            }}</span>

            <ion-button expand="block" type="submit" class="h1-submit"
              >Submit</ion-button
            >
          </form>
          <!-- form end -->
        </ion-col>
      </ion-row>
      <hr class="support-row" />
      <!-- content end -->
    </ion-content>
  </ion-page>
</template>
<script>
import { defineComponent } from "vue";
import {
  IonRow,
  IonCol,
  IonButton,
  IonPage,
  IonContent,
  IonIcon,
  IonInput,
  IonLabel,
  IonItem,
  IonToast,
  IonTextarea,
  alertController,
} from "@ionic/vue";
import axios from "axios";

const BASE_URI =
  process.env.VUE_APP_BASE_URI !== undefined
    ? process.env.VUE_APP_BASE_URI
    : "https://api.onecoffeeapp.com.au";

export default defineComponent({
  name: "SendEmailSupportPage",
  components: {
    IonRow,
    IonCol,
    IonButton,
    IonPage,
    IonContent,
    IonIcon,
    IonInput,
    IonLabel,
    IonItem,
    IonToast,
    IonTextarea,
  },
  data() {
    return {
      form: {
        name: "",
        email: "",
        message: "",
      },
      errors: {
        name: null,
        email: null,
        message: null,
      },
    };
  },
  methods: {
    async handleSubmit() {
      this.clearErrors();
      if (this.validateForm()) {
        let paramsData = {};

        paramsData = {
          name: this.form.name,
          email: this.form.email,
          message: this.form.message,
        };

        let axiosConfig = {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        };

        let result = await axios.post(
          BASE_URI + "/users/send-email-support",
          paramsData,
          axiosConfig
        );

        if (result.status === 200) {
          this.promptMessage =
            "Your message has been successfully sent to us. Thank you!";
          await this.presentAlert(result.status);
        } else {
          this.promptMessage = result.error;
          await this.presentAlert(result.status);
        }
      }
    },
    async presentAlert(status) {
      const alert = await alertController.create({
        message: this.promptMessage,
      });

      await alert.present();
      await alert.onDidDismiss();
      if (status == 200 || status === 500) window.location.href = "/home";
      else return;
    },
    validateForm() {
      let isValid = true;

      // Name validation
      if (!this.form.name) {
        this.errors.name = "Name is required";
        isValid = false;
      }

      // Email validation
      if (!this.form.email) {
        this.errors.email = "Email is required";
        isValid = false;
      } else if (!this.validateEmail(this.form.email)) {
        this.errors.email = "Please enter a valid email address";
        isValid = false;
      }

      // Message validation
      if (!this.form.message) {
        this.errors.message = "Message is required";
        isValid = false;
      }

      return isValid;
    },
    validateEmail(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(email);
    },
    clearErrors() {
      this.errors.name = null;
      this.errors.email = null;
      this.errors.message = null;
    },
  },
});
</script>

<style scoped>
.container-support {
  padding-top: 10%;
  padding-bottom: 3%;
  padding-left: 5%;
  padding-right: 5%;
}
.back-icon {
  height: 20px;
  width: 20px;
}
.h1-label {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 100%;
  color: #1b1b1b;
}
.h1-text {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 100%;
  color: #1b1b1b;
}
.h1-submit {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 100%;
  color: #eeeeee;
  margin-top: 30px;
}
.support-row {
  border-top: 1px solid #f3f3f3;
  padding-left: 5%;
  padding-right: 5%;
  padding-top: 3%;
  padding-bottom: 3%;
}
.support-heading {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 140%;
  color: #1b1b1b;
  display: block;
  padding-top: 5px;
}
.support-txt {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  color: #1b1b1b;
  display: block;
  padding-top: 5px;
}
.arrowright-icon {
  text-align: right;
  padding-top: 8px;
}
.position-right {
  position: absolute;
  right: 20px;
}
.support-p {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  color: #666666;
  padding-left: 5%;
  padding-right: 5%;
}
</style>
